import styled from 'styled-components'
import warningIcon from '../assets/avatar-warning.svg'

type Props = { message: string; onClose: () => void }

/** 起動時の取得失敗を、アバターのフォールバックと独立して知らせる。 */
export const AvatarLoadNotice = ({ message, onClose }: Props) => (
  <Notice role="alert">
    <Body>
      <img src={warningIcon} width="20" height="20" alt="" />
      <p>{message}</p>
    </Body>
    <Close type="button" aria-label="アバターの通知を閉じる" onClick={onClose}>
      <span aria-hidden="true">×</span>
    </Close>
  </Notice>
)

const Notice = styled.div`
  position: fixed;
  right: 0;
  bottom: calc(275px + env(safe-area-inset-bottom, 0px));
  max-width: calc(100vw - 30px);
  z-index: 20;
`
const Body = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px;
  border: 0.5px solid white;
  border-radius: 10px 0 0 10px;
  background: linear-gradient(90deg, rgba(255,255,255,0.97), rgba(255,255,255,0.94) 58.173%, rgba(255,255,255,0.8));
  img { flex-shrink: 0; }
  p { margin: 0; width: 239px; max-width: calc(100vw - 110px); color: #666; font-size: 12px; line-height: 1.2; white-space: pre-line; }
`
const Close = styled.button`
  position: absolute;
  top: -15px;
  left: -15px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: white;
  color: #666;
  box-shadow: 0 4px 2px rgba(0,0,0,0.1);
  cursor: pointer;
  span { font-size: 25px; line-height: 16px; }
`
